var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_638_1157",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 11,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17822 0.675613H18.0002V9.00018H7.17822V0.675613Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_638_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 0.900366V9.0002C10.8001 4.7704 14.4001 9.18024 18.0003 4.95011C14.4004 6.47997 10.8005 -0.629854 7.2002 0.900009V0.900366Z",
    fill: "#001EFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_638_1157",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 9,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.00018V18H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_638_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.40045 14.0404V0.90046C5.40045 0.360507 5.04039 0.000442505 4.50043 0.000442505C3.96048 0.000442505 3.60042 0.360507 3.60042 0.90046V14.0404C1.53042 14.2204 0.000488281 15.0305 0.000488281 16.0204C0.000488281 17.1003 1.98045 18.0003 4.5004 18.0003C7.02035 18.0003 9.00031 17.1003 9.00031 16.0204C9.00031 15.0303 7.4703 14.2203 5.40038 14.0404H5.40045Z",
    fill: "#001EFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.e067bd8bf14b96bf420e52314ad02560.svg";
export { ForwardRef as ReactComponent };